import React from 'react';
import { Separator } from '../ui/separator';
import { Progress } from '../ui/progress';
import { BarChart3, Zap, Database } from 'lucide-react';

const UsageSettings = () => {
  // Mock data - in production, this would come from the backend
  const apiCalls = {
    used: 42,
    limit: 100,
    percentage: 42
  };

  const skills = {
    used: 3,
    limit: 10,
    percentage: 30
  };

  const stats = {
    totalCalls: 42,
    avgDaily: 1.4,
    peakDay: 8
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-text-dark dark:text-dark-text mb-2">Usage</h2>
        <p className="text-text-gray dark:text-dark-text-secondary">
          Monitor your application usage
        </p>
      </div>

      {/* API Calls Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <Zap className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-semibold text-text-dark dark:text-dark-text">API Calls</h3>
        </div>

        <div className="max-w-2xl p-6 border border-gray-200 dark:border-[#2e2e2d] rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm font-medium text-text-dark dark:text-dark-text">
              Current Month Usage
            </p>
            <p className="text-sm text-text-gray dark:text-dark-text-secondary">
              {apiCalls.used} / {apiCalls.limit}
            </p>
          </div>
          <Progress value={apiCalls.percentage} className="h-2 mb-2" />
          <p className="text-xs text-text-gray dark:text-dark-text-secondary">
            {apiCalls.percentage}% of your monthly limit
          </p>
        </div>
      </div>

      <Separator />

      {/* Skills Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <Database className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-semibold text-text-dark dark:text-dark-text">Skills</h3>
        </div>

        <div className="max-w-2xl p-6 border border-gray-200 dark:border-[#2e2e2d] rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm font-medium text-text-dark dark:text-dark-text">
              Skills Created
            </p>
            <p className="text-sm text-text-gray dark:text-dark-text-secondary">
              {skills.used} / {skills.limit}
            </p>
          </div>
          <Progress value={skills.percentage} className="h-2 mb-2" />
          <p className="text-xs text-text-gray dark:text-dark-text-secondary">
            {skills.percentage}% of your skill limit
          </p>
        </div>
      </div>

      <Separator />

      {/* Usage Statistics Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <BarChart3 className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-semibold text-text-dark dark:text-dark-text">Usage Statistics</h3>
        </div>

        <div className="max-w-2xl">
          <p className="text-sm text-text-gray dark:text-dark-text-secondary mb-4">
            Last 30 days
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="p-4 border border-gray-200 dark:border-[#2e2e2d] rounded-lg">
              <p className="text-sm text-text-gray dark:text-dark-text-secondary mb-1">
                Total Calls
              </p>
              <p className="text-2xl font-bold text-text-dark dark:text-dark-text">
                {stats.totalCalls}
              </p>
            </div>

            <div className="p-4 border border-gray-200 dark:border-[#2e2e2d] rounded-lg">
              <p className="text-sm text-text-gray dark:text-dark-text-secondary mb-1">
                Average Daily
              </p>
              <p className="text-2xl font-bold text-text-dark dark:text-dark-text">
                {stats.avgDaily}
              </p>
            </div>

            <div className="p-4 border border-gray-200 dark:border-[#2e2e2d] rounded-lg">
              <p className="text-sm text-text-gray dark:text-dark-text-secondary mb-1">
                Peak Day
              </p>
              <p className="text-2xl font-bold text-text-dark dark:text-dark-text">
                {stats.peakDay}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsageSettings;
